import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=67fc7447"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports